import { useContext } from 'react';
import { VideoContext } from 'providers/Video';

const useVideo = () => useContext(VideoContext);

export default useVideo;
